
//Dev BASE_URL
export const BASE_URL = 'https://erp-backend-vercel.vercel.app'



export const role = localStorage.getItem("role");
export const Name = localStorage.getItem("contactPerson");
export const branchId = localStorage.getItem("branchId");
export const branchName = localStorage.getItem("branchName");